import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import {
  Card,
  CardBody,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import HandWorkTable from "./HandWorkTable"
import DeleteModel from "common/deleteModel/deleteModel"
import { exportDataExcel } from "components/Common/ExportData"
import { dateFormat } from "pages/Common"
import ErrorModel from "common/errorModel/errorModel"
import CreateHandWorkModel from "./CreateHandWorkModel"
import AddWorkerDetailsModel from "./AddWorkerDetailsModel"
import { GetObjByHandWorkCostingStatus } from "_mock/Static_data"
import AddCostModel from "./AddCostModel"
import uploadImage from "../../assets/images/no_image.jpg"
import HandWorkDetailModel from "./HandWorkDetailModel"
import StitchingStatusChangeWorkersEndTimeSetModel from "./StitchingStatusChangeWorkersEndTimeSetModel"

function HandWork() {
  document.title = `Hand Work | Raja Rani Couture`
  let { pathname } = useLocation()
  const { deleteApi, getApi, postApi, putApi } = useApi()
  // useStates
  const [modal, setModal] = useState(false)
  const [addWorkerModal, setAddWorkerModal] = useState(false)
  const [addCostModal, setAddCostModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editData, setEditData] = useState(null)
  const [tableData, setTableData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [screenLoad, setScreenLoad] = useState(false)
  const [searchText, setSearchText] = useState("")
  const [isMobile, setisMobile] = useState(window.innerWidth < 768)
  const [displayStart, setDisplayStart] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(20)
  const [userFilter, setUserFilter] = useState(0)
  const [users, setUsers] = useState([])
  const [dateFilter, setDateFilter] = useState([new Date(), new Date()])
  const [dateDisble, setdateDisble] = useState(false)
  const [totalRecords, setTotalRecords] = useState(0)
  const [statusFilter, setStatusFilter] = useState([2])
  const [handWorkId, setHandWorkId] = useState(0)
  const [uniqueNo, setuniqueNo] = useState(0)
  const [handworkStatus, setHandworkStatus] = useState(0)
  const [imageViewModal, setImageViewModal] = useState(false)
  const [image1, setImage1] = useState('')
  const [image2, setImage2] = useState('')
  const [image3, setImage3] = useState('')
  const [handWorkCostDetailModel, setHandWorkCostDetailModel] = useState(false)
  const [TaskTitleTypes, setTaskTitleTypes] = useState(
    (JSON.parse(localStorage?.getItem("authUser")).TaskTitleTypes))
  const [standardHours, setStandardHours] = useState('')
  const [updateEndDateTimeModal, setUpdateEndDateTimeModal] = useState(false)

  // filter data for user
  const filterData = textFilter => {
    setSearchText(textFilter == undefined ? '' : textFilter)
  }

  const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
    setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
    setSearchText(serchValue == undefined ? "" : serchValue)
    setRowsPerPage(pageSize)
  }

  useEffect(() => {
    getApi('HandWorkCosting/designer/lookup').then(({ data, status }) => {
      if (status === 200) {
        setUsers(data)
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
    })

    postApi("Setting/setting-by-keys", {
      Key: ["WORKER_STANDARD_TIME"]
    }).then(({ data, status }) => {
      if (status === 200) {
        const [start, end] = data[0].Value?.split("|"); // ["8:30", "19:30"]

        const [sh, sm] = start?.split(":").map(Number);
        const [eh, em] = end?.split(":").map(Number);

        const startMinutes = sh * 60 + sm;
        const endMinutes = eh * 60 + em;

        let diffMinutes = endMinutes - startMinutes;
        if (diffMinutes < 0) diffMinutes += 24 * 60;

        const hours = Math.floor(diffMinutes / 60);
        const minutes = diffMinutes % 60;
        setStandardHours(`${hours}:${minutes}`)
      } else {

      }
    })
  }, [])

  // user list api
  const HandWorkListApi = () => {
    setUpdateEndDateTimeModal(false)
    setIsLoading(true)
    setScreenLoad(true)
    postApi("HandWorkCosting/list", {
      fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
        dateFilter[0],
        "yyyy-MM-dd"
      ) : new Date().toISOString().slice(0, 10),
      toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
        dateFilter[1],
        "yyyy-MM-dd"
      ) : new Date().toISOString().slice(0, 10),
      designerId: parseInt(userFilter),
      Status: statusFilter?.join(',') || '',
      displayStart: displayStart,
      pageSize: rowsPerPage,
      searchText: searchText.trim(),
      sortColumn: "",
      sortOrder: "asc",
    }).then(({ data, status }) => {
      if (status === 200) {
        setTableData(data?.HandWorkList)
        setTotalRecords(data?.TotalRecords)
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
      setIsLoading(false)
      setScreenLoad(false)
    })
  }

  // user list api useEffect
  useEffect(() => {
    if (dateFilter[1] != undefined) {
      HandWorkListApi()
    }
  }, [searchText, displayStart, rowsPerPage, userFilter, dateFilter, dateDisble, statusFilter])

  // Delete user handler
  const handleDelete = Id => {
    setScreenLoad(true)
    if (Id) {
      DeleteModel.confirmDeleteInquiry({
        title: "Are you sure? ",
        text: "You want to delete this record permanently? ",
        isMobile,
      }).then(response => {
        if (response == true) {
          deleteApi(`HandWorkCosting/delete?id=${Id}`).then(
            async ({ data, status }) => {
              if (status === 200) {
                const updatedArray = tableData
                  .map(obj => (obj.Id !== Id ? obj : null))
                  .filter(Boolean)
                setTableData(updatedArray)
                toast.success("Sucessfully deleted", {
                  style: {
                    fontSize: "15px",
                  },
                })
              } else {
                ErrorModel.errormodel({
                  title: "Verify Handwork",
                  text: data,
                })
              }
              setScreenLoad(false)
            }
          )
        } else {
          setScreenLoad(false)
        }
      })
    }
  }

  // Update user handler
  const handleEditCustomer = (customerData) => {
    if (customerData) {
      setEditData(customerData)
      setIsEdit(true)
      setModal(!modal)
    }
  }

  const handleAddWorker = (Id, uniqueNo, status) => {
    if (Id) {
      setHandWorkId(Id)
      setuniqueNo(uniqueNo)
      setHandworkStatus(status)
      toggleWorker()
    }
  }

  const handleAddCost = (Id, uniqueNo, data) => {
    if (Id) {
      setHandWorkId(Id)
      setuniqueNo(uniqueNo)
      setEditData(data)
      toggleCost()
    }
  }

  // Create user handler
  const handleCustomerAttendClick = () => {
    setIsEdit(false)
    toggle()
  }

  // popup box handler
  const toggle = () => {
    setModal(!modal)
  }

  const toggleWorker = () => {
    setAddWorkerModal(!addWorkerModal)
  }

  const toggleCost = () => {
    setAddCostModal(!addCostModal)
  }

  const updateEndDateTimeToggle = () => {
    setUpdateEndDateTimeModal(!updateEndDateTimeModal)
  }

  const handleStatusChange = (data, status) => {
    setHandWorkId(data?.Id)
    DeleteModel.confirmDeleteInquiry({
      title: "Are you sure? ",
      text: "You want to change this status? ",
      isMobile,
    }).then(response => {
      if (response == true) {
        if (status == 4) {
          updateEndDateTimeToggle()
        } else {
          postApi("HandWorkCosting/status-change", {
            Id: data.Id,
            Status: parseInt(status),
            InputEndDateTime: null
          }).then(({ data, status }) => {
            if (status == 200) {
              HandWorkListApi()
              toast.success("successfully updated", {
                style: {
                  fontSize: "15px",
                },
              })
            } else {
              toast.error(data, {
                style: {
                  fontSize: "15px",
                },
              })
            }
          })
        }
      } else {
        setIsLoading(false)
      }
    })
  }

  const handleImageView = (Image1, Image2, Image3, uniqueNo) => {
    setImage1(Image1)
    setImage2(Image2)
    setImage3(Image3)
    setuniqueNo(uniqueNo)
    imageViewToggle()
  }

  const imageViewToggle = () => {
    setImageViewModal(!imageViewModal)
  }

  const toggleHandWorkDetailModel = () => {
    setHandWorkCostDetailModel(!handWorkCostDetailModel)
  }

  const handleViewHandWorkDetail = (Id) => {
    setHandWorkId(Id)
    toggleHandWorkDetailModel()
  }

  const handleDesignerChange = (designerId, handworkOrderId) => {
    DeleteModel.confirmDeleteInquiry({
      title: "Are you sure? ",
      text: "You want to update this designer? ",
      isMobile,
    }).then(response => {
      if (response == true) {
        putApi(`HandWorkCosting/update-designer`,
          {
            HandWorkOrderId: handworkOrderId,
            DesignerId: parseInt(designerId),
          }
        ).then(
          async ({ data, status }) => {
            if (status === 200) {
              HandWorkListApi()
              toast.success("Sucessfully updated", {
                style: {
                  fontSize: "15px",
                },
              })
            } else {
              toast.error(data, {
                style: {
                  fontSize: "15px",
                },
              })
            }
            setScreenLoad(false)
          }
        )
      } else {
        setScreenLoad(false)
      }
    })

  }

  // table headers & accessor
  const columns = useMemo(
    () => [
      {
        Header: "Order No",
        accessor: "OrderNo",
        width: "8%",
        Cell: ({ row }) => {
          return (
            <div style={{ textAlign: "center" }}>
              {(TaskTitleTypes == null) ?
                <div style={{ color: "blue", cursor: "pointer" }} onClick={() => handleViewHandWorkDetail(row.original.Id)}>
                  {row.original.OrderNo}
                </div>
                :
                <>{row.original.OrderNo}</>
              }
            </div>
          )
        },
      },
      {
        Header: "Image",
        accessor: "Image1",
        width: "5%",
        Cell: ({ row }) => {
          return (
            <>
              <div>
                <img
                  onClick={() => handleImageView(row.original.Image1, row.original.Image2, row.original.Image3, row.original.UniqueNo)}
                  style={{
                    cursor: "pointer",
                    border: "1px solid #ced4da",
                    borderRadius: "3px",
                  }}
                  width="50px"
                  height="60px"
                  src={row.original?.Image1 || uploadImage}
                />
              </div>
            </>
          )
        },
      },
      {
        Header: "Unique No",
        accessor: "UniqueNo",
        width: "8%",
      },
      {
        Header: "Designer",
        accessor: "DesignerByName,DesignerId",
        Cell: ({ row }) => {
          return (
            <>
              {
                TaskTitleTypes == null
                  ?
                  <div>
                    <Input
                      type="select"
                      value={row.original.DesignerId}
                      onChange={e => { handleDesignerChange(e.target.value, row.original.HandWorkOrderId) }}
                      className="form-control-sm"
                      bsSize="sm"
                      style={{ width: "150px" }}
                    >
                      {users.map((item, index) => {
                        return (
                          <option key={index} value={item.Key}>
                            {item.Value}
                          </option>
                        )
                      })}
                    </Input>
                  </div>
                  :
                  <div>{row.original.DesignerByName}</div>
              }
            </>
          )
        }

      },
      {
        Header: "Category",
        accessor: "CategoryName",
        width: "8%",
      },
      {
        Header: "No. of Worker",
        accessor: "NoOfWorkers",
        Cell: ({ row }) => {
          return (
            <div style={{ textAlign: "center" }}>
              {((TaskTitleTypes == null) || (TaskTitleTypes.includes("15"))) ?
                <div
                  style={{ color: "blue", cursor: "pointer" }}
                  onClick={() => handleAddWorker(row.original.Id, row.original.UniqueNo, row.original.Status)}
                >{row.original.NoOfWorkers}</div>
                :
                <div>
                  {row.original.NoOfWorkers}

                </div>
              }
            </div>
          )
        },
      },
      {
        Header: "Total Hours",
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Total Hours
          </div>
        ),
        accessor: "TotalHours",
        width: "8%",
        Cell: ({ row }) => {
          return (
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center"
            }}>
              {row?.original?.TotalHours}
            </div>
          )
        },
      },
      {
        Header: "Worker Cost",
        Header: () => (
          <div
            style={{
              textAlign: "right",
            }}
          >
            Worker Cost
          </div>
        ),
        accessor: "WorkerCost",
        width: "8%",
        Cell: ({ row }) => {
          return (
            <div style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "end",
              textAlign: "end"
            }}>
              <i className="mdi mdi-currency-inr"></i>
              {new Intl.NumberFormat('en-IN', {
                currency: 'INR',
                minimumFractionDigits: 2,
              }).format(Math.round(row?.original?.WorkerCost) || 0)}
            </div>
          )
        },
      },
      {
        Header: "Material Cost",
        Header: () => (
          <div
            style={{
              textAlign: "right",
            }}
          >
            Material Cost
          </div>
        ),
        accessor: "MaterialCost",
        width: "8%",
        Cell: ({ row }) => {
          return (
            <div style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "end",
              textAlign: "end"
            }}>
              <i className="mdi mdi-currency-inr"></i>
              {new Intl.NumberFormat('en-IN', {
                currency: 'INR',
                minimumFractionDigits: 2,
              }).format(row?.original?.MaterialCost || 0)}
            </div>
          )
        },
      },
      {
        Header: "Other Cost",
        Header: () => (
          <div
            style={{
              textAlign: "right",
            }}
          >
            Other Cost
          </div>
        ),
        accessor: "OtherCost",
        width: "8%",
        Cell: ({ row }) => {
          return (
            <div style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "end",
              textAlign: "end"
            }}>
              <i className="mdi mdi-currency-inr"></i>
              {new Intl.NumberFormat('en-IN', {
                currency: 'INR',
                minimumFractionDigits: 2,
              }).format(row?.original?.OtherCost || 0)}
            </div>
          )
        },
      },
      {
        Header: "Total Cost",
        Header: () => (
          <div
            style={{
              textAlign: "right",
            }}
          >
            Total Cost
          </div>
        ),
        accessor: "TotalCost",
        width: "8%",
        Cell: ({ row }) => {
          return (
            <div style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "end",
              textAlign: "end"
            }}>
              <i className="mdi mdi-currency-inr"></i>
              {new Intl.NumberFormat('en-IN', {
                currency: 'INR',
                minimumFractionDigits: 2,
              }).format(Math.round(row?.original?.MaterialCost + row?.original?.WorkerCost + row?.original?.OtherCost) || 0)}
            </div>
          )
        },
      },
      {
        Header: "Created On",
        accessor: "CreatedOn",
        width: "9%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original?.CreatedOn == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(row.original?.CreatedOn?.split("T")[0], "dd-MM-yyyy")}
          </p>
        ),
      },
      {
        Header: "Status",
        accessor: "Status",
        width: "10%",
        Cell: ({ row }) => (
          <div>
            <Input
              disabled={row.original.Status == 5 || row.original.NoOfWorkers == 0}
              type="select"
              bsSize="sm"
              id="validationCustom01"
              className="form-control-sm"
              style={{ width: "110px" }}
              onChange={e => {
                handleStatusChange(row.original, e.target.value)
              }}
              value={row.original.Status}
            >
              {row.original.Status == 1 ?
                <>
                  {GetObjByHandWorkCostingStatus(1, 2, 3).map((item, index) => {
                    return (
                      <option key={index} value={item.Value}>
                        {item.Key}
                      </option>
                    )
                  })}
                </>
                :
                row.original.Status == 2 ?
                  <>
                    {GetObjByHandWorkCostingStatus(2, 3, 4).map((item, index) => {
                      return (
                        <option key={index} value={item.Value}>
                          {item.Key}
                        </option>
                      )
                    })}
                  </>
                  :
                  row.original.Status == 3 ?
                    <>
                      {GetObjByHandWorkCostingStatus(2, 3).map((item, index) => {
                        return (
                          <option key={index} value={item.Value}>
                            {item.Key}
                          </option>
                        )
                      })}
                    </>
                    :
                    row.original.Status == 4 ?
                      <>
                        {GetObjByHandWorkCostingStatus(4, 5).map((item, index) => {
                          return (
                            <option key={index} value={item.Value}>
                              {item.Key}
                            </option>
                          )
                        })}
                      </>
                      :
                      <>
                        {GetObjByHandWorkCostingStatus(5).map((item, index) => {
                          return (
                            <option key={index} value={item.Value}>
                              {item.Key}
                            </option>
                          )
                        })}
                      </>
              }

            </Input>
          </div>
        )
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Action
          </div>
        ),
        width: "12%",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
              {((TaskTitleTypes == null) || (TaskTitleTypes.includes("15"))) &&
                <>
                  <li className="mytooltip">
                    <i
                      className="fs-6 fas fa-money-bill-alt"
                      id={`edittooltip${row.original.Id}`}
                      style={{ color: "#556ee6" }}
                      onClick={() => handleAddCost(row.original.Id, row.original.UniqueNo, row.original)}
                    ></i>
                    <span className="mytext">Add Cost</span>
                  </li>
                </>
              }

              {((TaskTitleTypes == null) || (TaskTitleTypes.includes("14"))) &&
                <li className="mytooltip">
                  <i
                    className=" fs-6 fas fa-edit btn-edit"
                    id={`edittooltip${row.original.Id}`}
                    onClick={() => handleEditCustomer(row.original)}
                  ></i>
                  <span className="mytext">Edit</span>
                </li>
              }

              {(TaskTitleTypes == null) &&
                <>
                  {row.original.Status != 1
                    ?
                    <li className="mytooltip">
                      <i
                        className={`fs-6 fas fa-trash-alt btn-delete`}
                        style={{ cursor: "not-allowed", color: "#808080b3" }}
                      ></i>
                      <span className="mytext">Delete</span>
                    </li>
                    :
                    <li className="mytooltip">
                      <i
                        className="fs-6 fas fa-trash-alt btn-delete"
                        id={`deletetooltip${row.original.Id}`}
                        onClick={() => handleDelete(row.original.Id)}
                      ></i>
                      <span className="mytext">Delete</span>
                    </li>
                  }
                </>
              }
            </ul>
          )
        },
      },
    ],
    [tableData, users]
  )

  function writeDataToExcel() {
    if (!dateDisble) {
      toast.error("Please Select date", {
        icon: "⚠️",
        style: {
          fontSize: "15px",
        },
      })
    } else {
      setIsLoading(true)
      let header = ["Unique No", "Order No.", "Designer", "Category", "No. of Worker", "Total Hours", "Worker Cost", "Material Cost", "Other Cost", "Total Cost", "Status", "Created On"];
      const mainTitle = "Hand Work";
      const widthObj = [{
        Key: "A",
        Value: 10,
      },
      {
        Key: "B",
        Value: 19,
      },
      {
        Key: "C",
        Value: 19,
      },
      {
        Key: "D",
        Value: 19,
      },
      {
        Key: "E",
        Value: 19,
      },
      {
        Key: "F",
        Value: 19,
      },
      {
        Key: "G",
        Value: 19,
      },
      {
        Key: "H",
        Value: 19,
      },
      {
        Key: "I",
        Value: 19,
      },
      {
        Key: "J",
        Value: 19,
      },
      ]
      const extention = "Hand_Work_Cost.xlsx"
      let excelSheetData = []

      postApi("HandWorkCosting/list", {
        fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
          dateFilter[0],
          "yyyy-MM-dd"
        ) : new Date().toISOString().slice(0, 10),
        toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
          dateFilter[1],
          "yyyy-MM-dd"
        ) : new Date().toISOString().slice(0, 10),
        designerId: parseInt(userFilter),
        Status: statusFilter?.join(',') || '',
        displayStart: displayStart,
        pageSize: 10000,
        searchText: searchText.trim(),
        sortColumn: "",
        sortOrder: "asc",
      }).then(({ data, status }) => {
        if (status === 200) {
          for (let index = 0; index < data?.HandWorkList.length; index++) {
            let dataObj = {
              UniqueNo: data?.HandWorkList[index].UniqueNo,
              OrderNo: data?.HandWorkList[index].OrderNo,
              Designer: data?.HandWorkList[index].DesignerByName,
              Category: data?.HandWorkList[index].CategoryName,
              NoOfWorkers: data?.HandWorkList[index].NoOfWorkers,
              TotalHours: data?.HandWorkList[index].TotalHours,
              WorkerCost: Math.round(data?.HandWorkList[index].WorkerCost).toFixed(2),
              MaterialCost: Math.round(data?.HandWorkList[index].MaterialCost).toFixed(2),
              OtherCost: Math.round(data?.HandWorkList[index].OtherCost).toFixed(2),
              TotalCost: Math.round(data?.HandWorkList[index].WorkerCost + data?.HandWorkList[index].MaterialCost + data?.HandWorkList[index].OtherCost).toFixed(2),
              Status: GetObjByHandWorkCostingStatus(data?.HandWorkList[index].Status)[0]?.Key,
              CreatedOn: data?.HandWorkList[index].CreatedOn == null
                ? "N/A"
                : dateFormat(data?.HandWorkList[index].CreatedOn, "dd-MM-yyyy"),
            }
            excelSheetData.push(dataObj)
          }
          var fields = Object.keys(excelSheetData[0]);
          var sheetData = excelSheetData.map(function (row) {
            return fields.map(function (fieldName) {
              return row[fieldName];
            });
          });
          setIsLoading(false)
          sheetData.unshift(header);
          exportDataExcel(sheetData, mainTitle, widthObj, extention)
        } else {
          toast.error(data, {
            style: {
              fontSize: "15px",
            },
          })
        }
        setIsLoading(false)
        setScreenLoad(false)
      })

      setIsLoading(false)
    }
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        {screenLoad && (
          <div className="loading-overlay is-active">
            <span className="fas fa-spinner fa-3x fa-spin"></span>
          </div>
        )}
        <Breadcrumbs
          title={breadcrumbs[pathname].parent}
          breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
          link={breadcrumbs[pathname].parentLink}
        />
        <Card>
          <CardBody>
            <HandWorkTable
              columns={columns}
              data={tableData}
              isGlobalFilter={true}
              isAddUserList={true}
              handleCustomerAttendClick={handleCustomerAttendClick}
              customPageSize={10}
              className="custom-header-css"
              filterData={filterData}
              isLoading={isLoading}
              TotalRecords={totalRecords}
              pagePerSize={pagePerSize}
              setDateFilter={setDateFilter}
              dateFilter={dateFilter}
              users={users}
              userFilter={userFilter}
              setUserFilter={setUserFilter}
              setdateDisble={setdateDisble}
              dateDisble={dateDisble}
              writeDataToExcel={writeDataToExcel}
              statusFilter={statusFilter}
              setStatusFilter={setStatusFilter}
            />

            <AddWorkerDetailsModel
              modal={addWorkerModal}
              toggle={toggleWorker}
              HandWorkListApi={HandWorkListApi}
              handWorkId={handWorkId}
              uniqueNo={uniqueNo}
              handworkStatus={handworkStatus}
            />

            <AddCostModel
              modal={addCostModal}
              toggle={toggleCost}
              HandWorkListApi={HandWorkListApi}
              editData={editData}
              handWorkId={handWorkId}
              uniqueNo={uniqueNo}
              standardHours={standardHours}
            />

            <HandWorkDetailModel
              modal={handWorkCostDetailModel}
              toggle={toggleHandWorkDetailModel}
              handWorkId={handWorkId}
            />

            <CreateHandWorkModel
              modal={modal}
              toggle={toggle}
              HandWorkListApi={HandWorkListApi}
              isEdit={isEdit}
              editData={editData}
              designerId={JSON.parse(localStorage?.getItem("authUser"))?.Id}
              handworkOrderId={0}
            />

            {updateEndDateTimeModal &&
              <StitchingStatusChangeWorkersEndTimeSetModel
                modal={updateEndDateTimeModal}
                toggle={updateEndDateTimeToggle}
                HandWorkId={handWorkId}
                HandWorkOrderListApi={HandWorkListApi}
              />
            }

            <Modal
              isOpen={imageViewModal}
              toggle={imageViewToggle}
              centered={true}
              size="xl"
              style={{ width: isMobile ? "" : "1500" }}
            >
              <div className="modal-content">
                <ModalHeader toggle={imageViewToggle} tag="h5">
                  Unique No: {uniqueNo}
                </ModalHeader>
                <ModalBody>
                  <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                    <img
                      style={{
                        cursor: "pointer",
                        border: "1px solid #ced4da",
                        borderRadius: "3px",
                      }}
                      width="350px"
                      height="400px"
                      src={image1 || uploadImage}
                    />
                    <img
                      style={{
                        cursor: "pointer",
                        border: "1px solid #ced4da",
                        borderRadius: "3px",
                      }}
                      width="350px"
                      height="400px"
                      src={image2 || uploadImage}
                    />
                    <img
                      style={{
                        cursor: "pointer",
                        border: "1px solid #ced4da",
                        borderRadius: "3px",
                      }}
                      width="350px"
                      height="400px"
                      src={image3 || uploadImage}
                    />
                  </div>
                </ModalBody>
              </div>
            </Modal>

          </CardBody>
        </Card>
      </div>
    </div>
  )
}
HandWork.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
  onFilterChange: PropTypes.func,
}

export default HandWork
